import { useMutation } from 'react-query';
import paths from 'API/paths';
import axiosInstance from 'Services/axiosConfig';

export interface CreateContextPayload{
    projectId: string;
    contextName: string;
    contextDescription?: string | null;
    dataType?: 'STRING' | 'NUMBER'; // Add dataType field
}

const createContext = async (payload: CreateContextPayload) => {
  try {
    const url = paths.createContext();
    const response = await axiosInstance.post(url, {input: payload});
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const useCreateContext = () => {
  return useMutation(createContext);
};